// src/components/resume/FormInput.js
import React, { useId } from 'react';

const FormInput = ({
    label,
    name,
    value,
    onChange,
    placeholder,
    type = 'text', // <-- Add default type
    required = false, // <-- Add required prop
    autoComplete // <-- Add autocomplete prop
}) => {
    const reactId = useId();
    const fieldId = `${reactId}-${name}`;
    return (
        <div>
            <label htmlFor={fieldId} className="block text-xs font-bold text-neutral-400 uppercase mb-2">
                {label}{required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <input
                type={type} // <-- Use type prop
                id={fieldId}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required} // <-- Use required prop
                autoComplete={autoComplete} // <-- Use autocomplete prop
                className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/60 focus:border-transparent" // <-- Applied text-white
            />
        </div>
    );
};

export default FormInput;